import React from 'react';
import Badge from './Badge';

const ENV_VARIANTS = {
    development: 'info',
    staging: 'warning',
    production: 'danger',
};

export default function ScopeBadges({ environment, tags = [] }) {
    const envVariant = ENV_VARIANTS[(environment || '').toLowerCase()] || 'outline';

    return (
        <div className="inline-flex flex-wrap items-center gap-1">
            {environment && (
                <Badge variant={envVariant} dot>
                    {environment}
                </Badge>
            )}
            {tags && tags.length > 0 && tags.slice(0, 4).map((t) => (
                <Badge key={t} variant="outline">#{t}</Badge>
            ))}
            {tags && tags.length > 4 && (
                <Badge variant="outline">+{tags.length - 4}</Badge>
            )}
        </div>
    );
}
